import React from "react";
import Icon from './Icon';
import PropTypes from "prop-types";

export default class CheckCircle extends React.PureComponent {
    render() {
        let { color } = this.props;

        let img;

        switch (color) {
            case 'white':
                img = require('../../../assets/images/icons/check-circle-white.svg');
                break;
            case 'red':
                img = require('../../../assets/images/icons/check-circle-red.svg');
                break;
            case 'blue':
                img = require('../../../assets/images/icons/check-circle-blue.svg');
                break;
            default:
                img = require('../../../assets/images/icons/check-circle.svg');
                break;
        }

        return (
            <Icon className={'check-circle'} img={img}/>
        );
    }
}

CheckCircle.propTypes = {
    color: PropTypes.string,
};
